import { type ZodRawShape, z } from "zod";

export const loose = {
  boolean: () =>
    z.preprocess((val) => {
      if (val === "0" || val === "false") return false;
      return val;
    }, z.coerce.boolean()),
  number: () =>
    z.preprocess((val) => {
      if (val === "0" || val === "false" || !val) return 0;
      return val;
    }, z.coerce.number()),
};

export const EXPERIMENT_ON_OFF = {
  enabled: loose.boolean(),
} as const;

type PropertiesT = ZodRawShape;

export type ExperimentT<P = PropertiesT> = {
  name: string;
  properties: P;
};

export function defineExperiment<P extends typeof EXPERIMENT_ON_OFF>(name: string): ExperimentT<P>;
export function defineExperiment<P extends PropertiesT>(name: string, params: P): ExperimentT<P>;

export function defineExperiment(name: string, properties: PropertiesT = EXPERIMENT_ON_OFF) {
  return {
    name,
    properties,
  };
}
